import { Button } from '@calizahq/react-components-v2'
import { AgentMutations } from '@sales-app/graphql/mutations/agent.mutations'
import React from 'react'

import { useAlertContext } from '@/context'
import { useMobile } from '@/hooks'
import { useGraphqlMutation } from '@/hooks/useGraphql'

type Props = {
  agentId: number
  refetchOnSuccess: () => void
  toggle: () => void
}

export const DeleteAgent = ({ toggle, agentId, refetchOnSuccess }: Props) => {
  const { isTablet } = useMobile()
  const { setAlert } = useAlertContext()

  const { mutate, isPending: isMutationLoading } = useGraphqlMutation(AgentMutations.deleteAgent(), {
    onSuccess: () => {
      toggle()
      refetchOnSuccess()
      setAlert('Agent deleted.', 'success')
    },
  })

  const handleDeleteAgent = () => {
    mutate({ agentId })
  }

  return (
    <div className="flex w-full flex-col flex-wrap px-6 md:max-w-120">
      <h5 className="mb-4 text-header-sm leading-120 md:text-header-md">Are you sure you want to delete this Agent?</h5>
      <p className="mb-4 text-p-xs md:mb-8">
        You cannot restore a deleted Agent. If you need the Agent again for whatever reason, you must create a new one.
      </p>
      <div className="flex flex-col-reverse justify-between md:flex-row">
        <Button
          className="w-full bg-action-secondary md:flex md:w-auto"
          onClick={toggle}
          size={isTablet ? 'medium' : 'small'}
          variant="secondary"
        >
          Cancel
        </Button>
        <Button
          className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
          disabled={isMutationLoading}
          isLoading={isMutationLoading}
          onClick={handleDeleteAgent}
          size={isTablet ? 'medium' : 'small'}
        >
          Delete
        </Button>
      </div>
    </div>
  )
}
